var _circle, _circle2, _circle3, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 80,
    viewBox: "0 0 88 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 43.6304,
    cy: 27.8784,
    r: 16.1616,
    fill: "#FF8A5B"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 63.8321,
    cy: 27.879,
    r: 12.1212,
    fill: "#FF8A5B"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 23.4337,
    cy: 27.879,
    r: 12.1212,
    fill: "#FF8A5B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.1324 64.243H78.8985C79.4901 64.243 79.9478 63.7435 79.8559 63.159C79.1967 58.9658 75.9968 44.041 63.8419 44.041C60.2603 44.041 57.4563 45.3369 55.2656 47.2722C61.3552 51.2249 64.5041 58.1441 66.1324 64.243Z",
    fill: "#FF8A5B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.0079 47.2683C29.8179 45.3351 27.0152 44.041 23.436 44.041C11.2811 44.041 8.08112 58.9658 7.42193 63.159C7.33006 63.7435 7.78769 64.243 8.37932 64.243H21.1352C22.764 58.1421 25.9144 51.2204 32.0079 47.2683Z",
    fill: "#FF8A5B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6395 48.0801C61.3769 48.0801 63.5408 66.7681 63.8049 71.3281C63.8368 71.8794 63.3938 72.3225 62.8415 72.3225H24.4375C23.8852 72.3225 23.4423 71.8794 23.4742 71.3281C23.7382 66.7681 25.9022 48.0801 43.6395 48.0801Z",
    fill: "#FF8A5B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThi);
export default __webpack_public_path__ + "static/media/thi.31a7f8fa464c6c1f9fe4f25c22657085.svg";
export { ForwardRef as ReactComponent };